import { IFieldDefinition, ValueTypes, InputTypes, FieldViews } from 'app/interfaces';
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

const TYPE_PAYMENT_METHOD = 'payment_method';
const TYPE_VAT_CODE = 'vat_code';

const selectOptionsRemote = {
	limit: 100,
	getLabel(option): string{
		if(!option) return '';
		return option.label;
	},
	getValue(option): string{
		if(!option) return '';
		return option.value;
	},
	getDisplay(option): string{
		if(!option) return '';
		return option.label;
	}
};

/**
 * Il tipo è determinato dalla voce di menu, non scelto dall'operatore: campo nascosto con
 * default fisso, così ogni sezione crea solo mappature del proprio tipo.
 */
function hiddenTypeField(type: string): IFieldDefinition{
	return {
		key: 'type',
		name: '',
		inputType: InputTypes.HIDDEN,
		valueType: ValueTypes.STRING,
		fieldView: FieldViews.HIDDEN,
		formValidators: [ Validators.required ],
		defaultValue(){
			return type;
		}
	};
}

fieldsMap.set('type_payment_method', hiddenTypeField(TYPE_PAYMENT_METHOD));
fieldsMap.set('type_vat_code', hiddenTypeField(TYPE_VAT_CODE));

/**
 * Nostro metodo di pagamento (config/rt_mappings.php lato server)
 */
fieldsMap.set('source_code_payment', {
	key: 'source_code',
	name: 'Metodo di pagamento Tangerine',
	inputType: InputTypes.DATASET_SELECT,
	valueType: ValueTypes.STRING,
	datasetCode: 'select_options',
	formValidators: [ Validators.required ],
	inputHint: 'Metodo con cui il cliente paga',
	remoteOptions: Object.assign({
		getParams(): any{
			return { options_code: 'rt_payment_methods' };
		}
	}, selectOptionsRemote)
});

/**
 * Nostra fiscalità (property taxation dei pacchetti). Solo quelle trasmesse al Server RT:
 * sulle altre non c'è nulla da mappare e vederle marcate "(no RT)" confondeva.
 */
fieldsMap.set('source_code_taxation', {
	key: 'source_code',
	name: 'Fiscalità Tangerine',
	inputType: InputTypes.DATASET_SELECT,
	valueType: ValueTypes.STRING,
	datasetCode: 'select_options',
	formValidators: [ Validators.required ],
	inputHint: 'Fiscalità del pacchetto o del prodotto',
	remoteOptions: Object.assign({
		getParams(): any{
			return { options_code: 'taxation', target: 'trip_packages', only_rt: 1 };
		}
	}, selectOptionsRemote)
});

/**
 * PaymentCode del profilo Kiara Cloud: obbligatorio
 */
fieldsMap.set('target_code_payment', {
	key: 'target_code',
	name: 'Codice pagamento Server RT',
	inputType: InputTypes.DATASET_SELECT,
	valueType: ValueTypes.STRING,
	datasetCode: 'select_options',
	formValidators: [ Validators.required ],
	inputHint: 'Codice configurato sul Server RT',
	remoteOptions: Object.assign({
		getParams(): any{
			return { options_code: 'rt_payments' };
		}
	}, selectOptionsRemote)
});

/**
 * Natura IVA: da indicare solo quando l'aliquota è zero, altrimenti va lasciata vuota
 * (cfr. doc KiaraCloudAPI, campo vat_code di setDocumentRT)
 */
fieldsMap.set('target_code_vat', {
	key: 'target_code',
	name: 'Natura IVA Server RT',
	inputType: InputTypes.DATASET_SELECT,
	valueType: ValueTypes.STRING,
	datasetCode: 'select_options',
	inputHint: 'Solo per aliquota zero: lascia "Nessuna" per l\'IVA ordinaria',
	remoteOptions: Object.assign({
		getParams(): any{
			return { options_code: 'rt_vat_natures' };
		}
	}, selectOptionsRemote)
});

fieldsMap.set('vat_rate', {
	key: 'vat_rate',
	name: 'Aliquota Server RT',
	inputType: InputTypes.DATASET_SELECT,
	valueType: ValueTypes.NUMBER,
	datasetCode: 'select_options',
	inputHint: 'Lascia vuoto per usare l\'aliquota della fiscalità',
	remoteOptions: Object.assign({
		getParams(): any{
			return { options_code: 'rt_vats' };
		}
	}, selectOptionsRemote)
});

fieldsMap.set('notes', {
	key: 'notes',
	name: 'Dicitura riga documento',
	inputType: InputTypes.TEXTAREA,
	valueType: ValueTypes.STRING,
	inputHint: 'Testo stampato sulla riga (es. Escluso Art.74 ter D.P.R. 633/72)'
});

fieldsMap.set('target_description', {
	key: 'target_description',
	name: 'Descrizione Server RT',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

export { fieldsMap, TYPE_PAYMENT_METHOD, TYPE_VAT_CODE };
